import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { Bills } from "./Bill";


const BillManagementRoutes: FunctionComponent<RouteComponentProps> = ({
    match: { url }
  }) => (
    <Switch>
      <Route exact path={`${url}/`} render={() => <Bills />} />
      </Switch>
      );

export const BillManagement = withRouter(BillManagementRoutes);